/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { Cell } from './Cell';
import { Drawer, useDrawer } from '../Drawer';
import { getPublicRowStateProps } from '../../utils';
import { useFocus } from '../../../tools/utils';
const TableRow = ({ table, tableInstance, currentRow, }) => {
    const [colOneCellRef, setColOneCellFocus] = useFocus();
    useEffect(() => {
        if (currentRow.isFocused)
            setColOneCellFocus();
    }, [currentRow.isFocused, setColOneCellFocus]);
    const drawerValues = useDrawer({
        tableInstance,
        row: currentRow.data,
        drawer: table.drawer,
    });
    const tableCellContext = Object.assign(Object.assign({}, getPublicRowStateProps(currentRow.data)), { data: currentRow.data.original });
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", Object.assign({}, currentRow.data.getRowProps(), { onClick: () => { var _a, _b; return (_b = (_a = table.row) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, currentRow); }, key: currentRow.data.id }), currentRow.data.cells
            .filter(cell => !cell.column.isDrawerOnly)
            .map((cell, i) => (React.createElement(Cell, Object.assign({}, (i === 0 ? { ref: colOneCellRef } : {}), { colIndex: i, cell: cell, cellContext: tableCellContext, drawer: drawerValues, row: table.row, key: cell.column.id }), cell.render('Cell'))))),
        !!table.drawer && !!drawerValues.colCount && (React.createElement(Drawer, { tableInstance: tableInstance, row: currentRow.data, drawer: table.drawer, isOpen: drawerValues.isOpen, panelId: drawerValues.panelId, targetRef: drawerValues.targetRef }))));
};
export { TableRow };
//# sourceMappingURL=TableRow.js.map